import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  documenttypes: [],
  documenttype: {
    id: 0,
    name: "",
    description: "",
    code: "",
    status: false,
  },
  documenttypeValidation: {
    isValid: true,
    name: {
      isValid: true,
      errorMessage: "El campo nombre no debe estar vacio",
    },
    description: {
      isValid: true,
      errorMessage: "El campo descripción no debe estar vacio",
    },
    code: {
      isValid: true,
      errorMessage: "El campo código no debe estar vacio",
    },
  },
};

const documenttypeSlice = createSlice({
  name: "documenttype",
  initialState,
  reducers: {
    restartState(state) {
      state.documenttype = {};
      state.documenttypes = [];
    },
    setdocumenttypes(state, actions) {
      state.documenttypes = actions.payload.documenttypes;
      state.documenttype = {};
    },
    setDocumenttype(state, actions) {
      state.documenttype = actions.payload.documenttype;
      state.documenttypes = [];
    },
    modifyPropertyValue(state, actions) {
      state.documenttype[actions.payload.id] = actions.payload.value;
    },
    setdocumenttypeValidation(state, actions) {
      state.documenttypeValidation = {
        name: {
          ...state.documenttypeValidation.name,
          isValid: actions.payload.name !== "",
        },
        description: {
          ...state.documenttypeValidation.description,
          isValid: actions.payload.description !== "",
        },
        code: {
          ...state.documenttypeValidation.code,
          isValid: actions.payload.code !== "",
        },
      };
      state.documenttypeValidation.isValid =
        state.documenttypeValidation.description.isValid;
    },
    setFieldValid(state, actions) {
      state.documenttypeValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const documenttypeActions = documenttypeSlice.actions;
export default documenttypeSlice;
